import { connect } from 'react-redux';
import { selectParentalPin, selectParentalError } from 'reducers/parental-lock/selectors';
import { setPin, setPinError } from 'actions/parental-lock';
import Page from './Page';

const mapStateToProps = (state) => {
  return {
    pin: selectParentalPin(state),
    error: selectParentalError(state),
  };
};

const mapDispatchToProps = {
  setPin,
  setPinError,
};

export default connect(mapStateToProps, mapDispatchToProps)(Page);
